import React from 'react';

import {
    AnySimpleDataType,
    ApiAdapterPromise,
    ApiAdapterRequestConfig,
    ApiResponse,
    CharacterPreferences,
    ChoiceData,
    DefinitionPool,
    FeatDefinitionContract,
    FeatLookup,
    OptionalOriginLookup,
    PrerequisiteData,
    RacialTrait,
    RacialTraitUtils,
} from '@dndbeyond/character-rules-engine/es';

import { RaceManageRacialTrait } from '../../containers/pages/RaceManage';

interface Props {
    racialTraits: Array<RacialTrait>;
    featLookup: FeatLookup;
    loadAvailableFeats: (
        additionalConfig?: Partial<ApiAdapterRequestConfig>,
    ) => ApiAdapterPromise<ApiResponse<Array<FeatDefinitionContract>>>;
    handleRacialTraitChoiceChange: (
        racialTraitId: number,
        choiceId: string,
        choiceType: number,
        optionValue: AnySimpleDataType,
    ) => void;
    choiceInfo: ChoiceData;
    prerequisiteData: PrerequisiteData;
    preferences: CharacterPreferences;
    optionalOriginLookup: OptionalOriginLookup;
    definitionPool: DefinitionPool;
    raceName?: string | null;
}

const RacialTraitList: React.FC<Props> = ({
    racialTraits,
    featLookup,
    loadAvailableFeats,
    handleRacialTraitChoiceChange,
    choiceInfo,
    prerequisiteData,
    preferences,
    optionalOriginLookup,
    definitionPool,
    raceName,
}) => {
    return (
        <>
            {racialTraits.map((racialTrait) => (
                <RaceManageRacialTrait
                    key={RacialTraitUtils.getId(racialTrait)}
                    racialTrait={racialTrait}
                    featLookup={featLookup}
                    loadAvailableFeats={loadAvailableFeats}
                    onChoiceChange={handleRacialTraitChoiceChange}
                    choiceInfo={choiceInfo}
                    prerequisiteData={prerequisiteData}
                    preferences={preferences}
                    optionalOriginLookup={optionalOriginLookup}
                    definitionPool={definitionPool}
                    raceName={raceName}
                />
            ))}
        </>
    );
};

export default RacialTraitList;
